import ManufacturersForm from './ManufacturersForm'
import MainLayout from '../../components/Layout'

function CreateManufacture() {
  return (
    <MainLayout>
      <div className="w-full flex flex-col items-center  mb-5 sm:mb-0 h-auto">
        <h1 className="admin-dashboard"> {'Create New Manufacturer'}</h1>
        <ManufacturersForm />
      </div>
    </MainLayout>
  )
}

export default CreateManufacture
